import { useState } from 'react';
import { AddAnchorPicker } from './AddAnchorPicker';

export function AddAnchorButton() {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className="rounded border border-amber-300 bg-amber-50 px-2 py-1 text-xs text-amber-800 hover:bg-amber-100"
      >
        ⚓ Add anchor
      </button>
      {open && <AddAnchorPicker onClose={() => setOpen(false)} />}
    </>
  );
}
